// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import AnalyticsBase from '../AnalyticsBase';
import AnalyticsFilterBar from '../AnalyticsFilterBar';
import BreadcrumbNav from '../../nav/BreadcrumbNav';

import { initializeAnalytics } from '../../../state/reducer/analytics/actionCreators/initializeAnalytics';
import loadMarketplaceProducts from '../../../state/reducer/analytics/actionCreators/loadMarketplaceProducts';
import * as DateUtils from '../../../lib/dateUtils';
import * as AnalyticsState from '../../../state/reducer/analytics/analytics';
import * as AppState from '../../../state/reducer/app/appState';

import Console from '../../../lib/debug';
import KPIBar from '../KPIBar';

type Props = {
    dispatch: any => void
};

const PAGE_KEY = 'marketplace-transactions';
const minDate = moment('2019-03-01', 'YYYY-MM-DD');

class MarketplaceTransactionsView extends Component<Props> {
    constructor(props: Props) {
        super(props);
        loadMarketplaceProducts(this.props.dispatch);
    }

    componentDidUpdate(prevProps: {}, prevState: {}) {
        this.loadAnalytics();
    }

    loadAnalytics = () => {
        const dataParams = this.getDataParams();
        if (!dataParams.team_id || dataParams.team_id.length === 0) {
            AppState.stopLoadingAnalytics();
            return;
        }
        this.props.dispatch(initializeAnalytics(PAGE_KEY, dataParams));
    };

    setSearchParams = (params: {}) => {
        const existingParams = AnalyticsState.getSearchParams();
        AnalyticsState.updateSearchParams({
            ...existingParams,
            ...params
        });
    };

    getDataParams = () => {
        const searchParams = AnalyticsState.getSearchParams();

        let startDate = searchParams.start_date;
        if (!DateUtils.isValidDateString(startDate)) {
            startDate = moment().startOf('month');
        } else {
            startDate = moment(startDate);
        }

        if (startDate.isBefore(minDate)) {
            startDate = minDate.clone();
        }

        let endDate = startDate.clone().endOf('month');
        endDate = moment(endDate, DateUtils.CALENDAR_FORMAT);

        const teamId = parseInt(searchParams.team_id, 10);

        return {
            team_id: teamId,
            date_start: moment(startDate).format('YYYY-MM-DD'),
            date_end: moment(endDate).format('YYYY-MM-DD')
        };
    };

    getSelectedTeamId = () => {
        const params = this.getDataParams();
        if (params.team_id) {
            return params.team_id;
        }
        return undefined;
    };

    getStartDate = () => {
        const dataParams = this.getDataParams();
        return moment(dataParams.date_start);
    };

    getEndDate = () => {
        const dataParams = this.getDataParams();
        return moment(dataParams.date_end);
    };

    onSelectDateRange = ({ startDate }: {}) => {
        const formattedStartDate = startDate.format(DateUtils.CALENDAR_FORMAT);

        this.setSearchParams({
            start_date: formattedStartDate
        });
    };

    onSelectTeam = (ev: Event, { suggestion }: any) => {
        const { id } = suggestion;
        this.setSearchParams({
            team_id: id
        });
    };

    getPageTitle = () => {
        let title =
            this.props.metaTree &&
            this.props.metaTree.instances &&
            this.props.metaTree.instances[PAGE_KEY] &&
            this.props.metaTree.instances[PAGE_KEY].title;
        if (title) {
            return title;
        }
        return '';
    };

    render() {
        Console.render('MarketplaceTransactionsView');
        const dates = this.getDataParams();
        const crumbs = [
            {
                displayString: 'Analytics',
                link: `/analytics`,
                editable: false
            },
            {
                displayString: 'SUMMARY',
                link: `/analytics/marketplace-org-summary?start_date=${
                    dates.date_start
                }&end_date=${dates.date_end}`,
                editable: false
            },
            {
                displayString: this.getPageTitle(),
                link: null,
                editable: false
            }
        ];

        return (
            <div className="has-filter-bar">
                <BreadcrumbNav crumbs={crumbs} />
                <KPIBar />
                <AnalyticsFilterBar
                    monthSelection={{
                        minDate: minDate,
                        startDate: this.getStartDate(),
                        endDate: this.getEndDate(),
                        onChange: this.onSelectDateRange
                    }}
                    marketplaceProductSelector={{
                        selectedId: this.getSelectedTeamId(),
                        onSelect: this.onSelectTeam,
                        allOptionText: 'All Products'
                    }}
                />
                <AnalyticsBase includeKpi={true} />
            </div>
        );
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        ...ownProps,
        marketplaceProducts: state.analytics.marketplaceProducts,
        metaTree: state.analytics.metaTree
    };
};

export default connect(mapStateToProps)(MarketplaceTransactionsView);



// WEBPACK FOOTER //
// ./src/view/analytics/marketplace/MarketplaceTransactionsView.jsx